export const ALL_FORMS = ["BR", "PR", "CU", "OV", "PE", "EM", "MA", "RA", "HE", "TR"];
export const ONLY_ROUND_FORMS = ["BR"];
export const ONLY_FANCY_FORMS = ["PR", "CU", "OV", "PE", "EM", "MA", "RA", "HE", "TR"];

export const presets = [
  {
    qualityKey: "twsi",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "earth",
      clarity: ["SI2", "SI1", "VS2", "VS1", "VVS2", "VVS1", "IF", "FL"],
      color: ["G", "F", "E", "D"],
      cut: ["EX"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "twvs",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "earth",
      clarity: ["VS2", "VS1", "VVS2", "VVS1", "IF", "FL"],
      color: ["G", "F", "E", "D"],
      cut: ["EX"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "twif",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "earth",
      clarity: ["IF", "FL"],
      color: ["G", "F", "E", "D"],
      cut: ["EX"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "twvs",
    forms: ONLY_FANCY_FORMS,
    filters: {
      type: "earth",
      clarity: ["VS2", "VS1", "VVS2", "VVS1", "IF", "FL"],
      color: ["G", "F", "E", "D"],
      cut: [],
      polish: ["VG", "EX"],
      fancy_intensity: [],
      symmetry: ["VG", "EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "twif",
    forms: ONLY_FANCY_FORMS,
    filters: {
      type: "earth",
      clarity: ["IF", "FL"],
      color: ["G", "F", "E", "D"],
      cut: [],
      polish: ["VG", "EX"],
      fancy_intensity: [],
      symmetry: ["VG", "EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "rif",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "earth",
      clarity: ["IF", "FL"],
      color: ["E", "D"],
      cut: ["EX"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "dif",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "earth",
      clarity: ["IF", "FL"],
      color: ["D"],
      cut: ["EX"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["GIA"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "lab-evs2",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "lab",
      clarity: ["VS2", "VS1", "VVS2", "VVS1", "IF", "FL"],
      color: ["E", "D"],
      cut: ["EX", "ID"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["IGI"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "lab-eif",
    forms: ONLY_ROUND_FORMS,
    filters: {
      type: "lab",
      clarity: ["IF", "FL"],
      color: ["E", "D"],
      cut: ["EX", "ID"],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["IGI"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "lab-evs2",
    forms: ONLY_FANCY_FORMS,
    filters: {
      type: "lab",
      clarity: ["VS2", "VS1", "VVS2", "VVS1", "IF", "FL"],
      color: ["E", "D"],
      cut: [],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["IGI"],
      fastDelivery: false,
    }
  },
  {
    qualityKey: "lab-eif",
    forms: ONLY_FANCY_FORMS,
    filters: {
      type: "lab",
      clarity: ["IF", "FL"],
      color: ["E", "D"],
      cut: [],
      polish: ["EX"],
      fancy_intensity: [],
      symmetry: ["EX"],
      fluorescence: ["N"],
      institute: ["IGI"],
      fastDelivery: false,
    }
  }
];

export const getActiveValueLabelShared = (key: string, value: any, filters: any, activeFilters: any) => {
  if (value === null || value === undefined) return "";
  const filter = filters[key];

  if (!filter) return value;

  if (filter.type === 'bool') {
    return filter.values ? (filter.values[String(value)] || value) : value;
  }

  if (key === 'size' && typeof value === 'object') {
    const minStr = value.min.toLocaleString('de-DE', { minimumFractionDigits: 2 });
    const maxStr = value.max.toLocaleString('de-DE', { minimumFractionDigits: 2 });
    if (minStr === maxStr) return `${minStr} ct.`;
    if (value.max === filter.max) {
      return `min ${minStr} ct.`;
    }
    return `${minStr} - ${maxStr} ct.`;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) return "None";
    const sourceValues = (key === 'color' && activeFilters.colored) ? (filter.fancy_colors || {}) : (filter.values || {});
    const availableKeys = Object.keys(sourceValues);
    const labels = value.map(val => sourceValues[val] || val);

    if (filter.view === 'range' && value.length > 0 && availableKeys.length > 0) {
      if (value.length === availableKeys.length || value[value.length - 1] === availableKeys[availableKeys.length - 1]) {
        if (value.length > 1) {
          return "min " + labels[0];
        }
      }
    }

    if (value.length === availableKeys.length && availableKeys.length > 0) return "All";

    if (labels.length <= 3) return labels.join(", ");
    return `${labels[0]} + ${labels.length - 1} more`;
  }

  if (filter.values && filter.values[value]) {
    return filter.values[value];
  }

  if (filter.fancy_colors && filter.fancy_colors[value]) {
    return filter.fancy_colors[value];
  }

  if (typeof value === 'object' && value !== null) {
     if (key === 'price') {
       const minStr = value.min.toLocaleString('de-DE');
       const maxStr = value.max.toLocaleString('de-DE');
       if (minStr === maxStr) return `${minStr} €`;
       if (value.max === filter.max) {
         return `min ${minStr} €`;
       }
       return `${minStr} € - ${maxStr} €`;
     }
     if (value.min === value.max) return `${value.min}`;
     if (value.max === filter.max) {
       return `min ${value.min}`;
     }
     return `${value.min} - ${value.max}`;
  }
  return value;
};
